import { parseBackground, useSizing } from "lib/helpers"
import { PricingCards } from "schemas"
import { Container, Stack, styled } from "styled-system/jsx"

import PricingCardsItem from "./PricingCardsItem"

type Props = PricingCards

function Columns({
  content,

  backgroundColor1,
  backgroundColor2,
  backgroundStyle,
  sizingTop,
  sizingBottom,
}: Props) {
  return (
    <styled.div
      className="pricingCards"
      style={
        {
          background: parseBackground(
            backgroundColor1,
            backgroundColor2,
            backgroundStyle
          ),
          "--pt": useSizing(sizingTop),
          "--pb": useSizing(sizingBottom),
        } as React.CSSProperties
      }
      css={{
        // bg: "other.7",
        pt: "var(--pt, 85px)",
        pb: "var(--pb, 85px)",
      }}>
      <Container>
        <Stack
          direction={{ base: "column", lg: "row" }}
          alignItems={{ base: "center", lg: "stretch" }}
          justifyItems="center"
          rowGap={{ base: "48px", lg: "80px" }}
          columnGap={8}
          css={{ py: 8 }}>
          {content?.map((child, i) => (
            <PricingCardsItem key={`${i}${child._key}`} index={i} {...child} />
          ))}
        </Stack>
      </Container>
    </styled.div>
  )
}

export default Columns
export type { Props as ColumnsProps }
